<template>
  <div></div>
</template>

<script>
import API from "./http-common.js";
import config from "./config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      startTime: null,
      logoutMinutes: 60 * 60 * 1000, //60 mins
    };
  },
  computed: {
    userType() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.UserType;
    },
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
  },
  methods: {
    handleKeyDownOrClick(event) {
      if (event) {
        let currentTime = new Date().getTime();
        let timeElapsed = currentTime - this.startTime;
        this.startTime = new Date().getTime();
        if (
          timeElapsed >= this.logoutMinutes &&
          window.location.href.indexOf("/login") < 0
        ) {
          alert("Your session has expired. You will be logged out.");
          this.logout();
        }
      }
    },
    logout() {
      API.common
        .deleteToken({ Token: this.token })
        .then((response) => {
          if (response.data == true) {
            // this.$router.replace({
            //   name:
            //     this.userType == this.userTypeMainAdmin
            //       ? "mainAdminLogin"
            //       : "schoolUserLogin",
            // });
            window.location =
              this.userType == this.userTypeMainAdmin
                ? "/mainadmin/login"
                : "/login";
            localStorage.removeItem("cbstoken");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  mounted() {
    this.startTime = new Date().getTime();
    window.addEventListener("keydown", this.handleKeyDownOrClick);
    window.addEventListener("click", this.handleKeyDownOrClick);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeyDownOrClick);
    window.removeEventListener("click", this.handleKeyDownOrClick);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleKeyDownOrClick);
    window.removeEventListener("click", this.handleKeyDownOrClick);
  },
};
</script>


// WEBPACK FOOTER //
// src/Timeout.vue